__turbopack_context__.v({
  "Arrow": "_ktJya_Arrow",
  "BlueGreen": "_ktJya_BlueGreen",
  "ButtonDesktop": "_ktJya_ButtonDesktop",
  "ButtonMobile": "_ktJya_ButtonMobile",
  "CardText": "_ktJya_CardText",
  "CardTitle": "_ktJya_CardTitle",
  "Content": "_ktJya_Content",
  "Fetching": "_ktJya_Fetching",
  "Image": "_ktJya_Image",
  "ImageContainer": "_ktJya_ImageContainer",
  "ImageCred": "_ktJya_ImageCred",
  "Index": "_ktJya_Index",
  "Item": "_ktJya_Item",
  "Link": "_ktJya_Link",
  "PinkBlue": "_ktJya_PinkBlue",
  "PinkOrange": "_ktJya_PinkOrange",
  "PinkPurple": "_ktJya_PinkPurple",
  "Root": "_ktJya_Root",
  "Text": "_ktJya_Text",
  "TextContainer": "_ktJya_TextContainer",
  "TitleBottom": "_ktJya_TitleBottom",
  "TitleContainer": "_ktJya_TitleContainer",
  "TitleTop": "_ktJya_TitleTop",
  "Visible": "_ktJya_Visible",
  "White": "_ktJya_White",
});
